import { Settings } from "../api";
import { getSettingsLoading, getSessionUserId } from "../reducers";
import axios from "../api/axios";
import { displayAddress } from "../helpers/Address";
import { setSessionData } from "./session";

const honorificOptions = ["Mr", "Mrs", "Miss", "Ms"];

export const getProfile = (dispatch) => {
  dispatch(setSettingsLoading());
  return axios
    .get("api/profile")
    .then((response) => {
      dispatch(setSettingsError(false));
      let userSettings = response.data.data;
      userSettings.address = displayAddress(userSettings);
      if (honorificOptions.indexOf(userSettings.honorific) === -1) {
        userSettings.honorific_other = userSettings.honorific;
        userSettings.honorific = "Other";
      }
      if (!userSettings?.accounts) {
        userSettings.accounts = {
          credit_card: {},
          direct_debit: {},
        };
      }
      userSettings.accounts.direct_debit.number_masked = userSettings.accounts
        .direct_debit.number_masked
        ? userSettings.accounts.direct_debit.number_masked.substring(6)
        : "";

      dispatch(setSessionData(userSettings));
      dispatch(setSettingsCreditCard(userSettings.accounts.credit_card));
      dispatch(setSettingsDirectDebit(userSettings.accounts.direct_debit));
      dispatch(setSettingsPersonal(userSettings));
    })
    .catch((e) => {
      console.log("profile", e);
      dispatch(setSettingsError());
    });
};

export async function saveSettingsPersonal(values, dispatch, setErrors) {
  dispatch(setSettingsPersonalSaving());

  try {
    const response = await axios.post("api/profile", values);
    let userSettings = response.data.data;
    if (honorificOptions.indexOf(userSettings.honorific) === -1) {
      userSettings.honorific_other = userSettings.honorific;
      userSettings.honorific = "Other";
    }
    userSettings.address = displayAddress(userSettings);
    dispatch(setSettingsPersonal(userSettings));
    dispatch(setSettingsPersonalSuccess());
    if (typeof window.ga !== "undefined") {
      window.ga("send", "event", "Profile updated", "Profile updated");
    }
    setTimeout(() => {
      dispatch(setSettingsPersonalDone());
    }, 1000);
  } catch (error) {
    const obj = {};
    Object.keys(error.errors || {}).forEach((key) => {
      obj[key] = error.errors[key].join(" ");
    });
    setErrors(obj);
    dispatch(setSettingsPersonalError());
  }
}

export const saveSettingsPassword =
  (setting, event, formApi) => (dispatch, getStore) => {
    // Fetch the settings from store.
    const data = {};
    const userId = getSessionUserId(getStore());
    // Manipulate the data to match the format the API expects.
    data.user_id = userId;
    data.password = setting.password;
    data.password_conf = setting.password_conf;
    data.password_old = setting.password_old;

    dispatch(setSettingsPasswordSaving());

    Settings.save(data)
      .then((response) => {
        if (response.result !== "success") {
          throw response.errors;
        }

        // Show the success button.
        dispatch(setSettingsPasswordSuccess());

        // After 1 second, turn the success button back to a normal save button.
        setTimeout(function () {
          dispatch(setSettingsPasswordDone());
        }, 1000);
      })
      .catch((settingErrors) => {
        console.error(
          "-- Account Settings server validation error!",
          settingErrors
        );

        // Map the errors onto the form.
        // setError expects the errors as an array. Our API returns the error as a string so split to force it to become an array.
        Object.keys(settingErrors).map((field) =>
          formApi.setError(field, settingErrors[field].split("||"))
        );

        // Show the error button.
        dispatch(setSettingsPasswordError());
      });
  };

export const setSettingsBilling =
  (settings, user_id) => (dispatch, getStore) => {
    dispatch(setSettingsBillingSaving());

    setTimeout(function () {
      dispatch(setSettingsBillingSuccess());

      // After 1 second, turn the success button back to a normal save button.
      setTimeout(function () {
        dispatch(setSettingsBillingDone());
      }, 1000);
    }, 2000);
  };

export const setSettingsLoading = (settings) => ({
  type: "SET_SETTINGS_LOADING",
});

export const setSettingsError = (message = "Sorry, an error occurred") => ({
  type: "SET_SETTINGS_ERROR",
  message,
});

export const setSettingsPersonal = (settings) => ({
  type: "SET_SETTINGS",
  settings,
});

export const setSettingsPersonalSaving = () => ({
  type: "SET_SETTINGS_PERSONAL_SAVING",
});

export const setSettingsPersonalSuccess = (
  message = "Thank you, your save was successful"
) => ({
  type: "SET_SETTINGS_PERSONAL_SUCCESS",
  message,
});

export const setSettingsPersonalError = (
  message = "Sorry, an error occurred"
) => ({
  type: "SET_SETTINGS_PERSONAL_ERROR",
  message,
});

export const setSettingsPersonalDone = () => ({
  type: "SET_SETTINGS_PERSONAL_DONE",
});

export const setSettingsPasswordSaving = () => ({
  type: "SET_SETTINGS_PASSWORD_SAVING",
});

export const setSettingsPasswordSuccess = (
  message = "Thank you, your save was successful"
) => ({
  type: "SET_SETTINGS_PASSWORD_SUCCESS",
  message,
});

export const setSettingsPasswordError = (
  message = "Sorry, an error occurred"
) => ({
  type: "SET_SETTINGS_PASSWORD_ERROR",
  message,
});

export const setSettingsPasswordDone = () => ({
  type: "SET_SETTINGS_PASSWORD_DONE",
});

export const setSettingsBillingSaving = () => ({
  type: "SET_SETTINGS_BILLING_SAVING",
});

export const setSettingsBillingSuccess = (
  message = "Thank you, your save was successful"
) => ({
  type: "SET_SETTINGS_BILLING_SUCCESS",
  message,
});

export const setSettingsBillingError = (
  message = "Sorry, an error occurred"
) => ({
  type: "SET_SETTINGS_BILLING_ERROR",
  message,
});

export const setSettingsBillingDone = () => ({
  type: "SET_SETTINGS_BILLING_DONE",
});

export const setSettingsCreditCard = (card) => ({
  type: "SET_SETTINGS_CREDIT_CARD",
  card,
});

export const setSettingsDirectDebit = (card = {}) => ({
  type: "SET_SETTINGS_DIRECT_DEBIT",
  card,
});
